import { Tooltip, useTheme } from '@mui/material';
import { StyledLabelTagBox, StyledLabelTagValue } from './style';
import { useLocation } from 'react-router-dom';
import { useResponsive } from 'src/hooks/useResponsive';
import { getLabelTagBoxColors } from './getLabelTagBoxColors';

import { LabelTagBoxVariant } from './types';
export type { ColorCoding } from './types';

type BaseProps = {
  text: string;
  tagName: string;
  isLiftStationMobile?: boolean;
};

type Props = BaseProps & LabelTagBoxVariant;

export const LabelTagBox = ({ text, tagName, isLiftStationMobile, ...variantProps }: Props) => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useResponsive('down', 'md');
  const isSitesManagementRoute = location.pathname.includes('/sites-management');

  const { background, color, borderColor } = getLabelTagBoxColors(theme, variantProps);

  const maxLength = isSitesManagementRoute && isMobile ? 10 : 25;
  const displayValue = text.length > maxLength ? text.slice(0, maxLength) : text;

  return (
    <Tooltip
      title={text}
      componentsProps={{
        tooltip: { sx: { bgcolor: '#fff' } },
      }}
    >
      <StyledLabelTagBox
        isLiftStationMobile={isLiftStationMobile}
        background={background}
        color={borderColor}
        data-sm={`${background}-${tagName}`}
      >
        <StyledLabelTagValue
          data-sm="label-tag"
          isLiftStationMobile={isLiftStationMobile}
          sx={{ color }}
        >
          {displayValue}
        </StyledLabelTagValue>
      </StyledLabelTagBox>
    </Tooltip>
  );
};
